import { render, staticRenderFns } from "./TrangDanhSachCapDonVi.vue?vue&type=template&id=f4c15484&"
import script from "./TrangDanhSachCapDonVi.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachCapDonVi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports